import { createContext, useContext } from "react";
import { Project, CustomNode, CustomEdge } from '../types';

export interface ProjectContextType {
  project: Project | null;
  projects: Project[];
  isLoading: boolean;
  error: Error | null;
  setProject: (project: Project | null) => void;
  updateProjectNodes: (nodes: CustomNode[]) => void;
  updateProjectEdges: (edges: CustomEdge[]) => void;
  loadProject: (projectId: string, isPreview?: boolean) => Promise<void>;
  loadProjects: () => Promise<void>;
  saveProject: () => Promise<void>;
  renameProject: (name: string, description?: string) => Promise<void>; // Updated signature
  shareProject: (projectId: string, email: string) => Promise<Project | { message: string } | undefined>;
  loadFromTemplate: (templateId: string) => Promise<void>;
  isPreviewMode: boolean;
}

export const ProjectContext = createContext<ProjectContextType | null>(null);

export function useProjectContext() {
  const context = useContext(ProjectContext);
  if (!context) {
    throw new Error('useProjectContext must be used within a ProjectProvider');
  }
  return context;
}

export function useRequireProject() {
  const { project } = useProjectContext();
  if (!project) {
    throw new Error('This operation requires an active project');
  }
  return project;
}
